'use strict';

angular.module('BusinessUnitsControllers', [
    'ngAnimate',
    'ui.bootstrap',
    'mgcrea.ngStrap',
    'angularMoment',
    'services.search',
    'services.businessSystem',
    'services.adminBusinessUnits'
]);

